import { render, staticRenderFns } from "./NewDeliveryMethod.vue?vue&type=template&id=9ebd2902&scoped=true&"
import script from "./NewDeliveryMethod.vue?vue&type=script&lang=js&"
export * from "./NewDeliveryMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ebd2902",
  null
  
)

export default component.exports